import React from "react";
import "./operationlayout.css";
import { Outlet } from "react-router-dom";

export default function OperationLayout() {

    return (
        <>
            <Outlet/>      
        </>   
    )
}
